import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpStatusCode,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { AppService } from '../services'
@Injectable()
export class InterceptorAppPermission implements HttpInterceptor {
	constructor(private appService: AppService, private router: Router) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((event: any) => {
				if (event instanceof HttpErrorResponse && event.status === HttpStatusCode.ImATeapot) {
					this.appService.reauthorize()

					console.log('hm')
				}
				if (event instanceof HttpErrorResponse && event.status === HttpStatusCode.Unauthorized) {
					if (environment.production) {
						this.appService.reauthorize()
					}
				}
				if (event instanceof HttpErrorResponse && event.status === HttpStatusCode.PaymentRequired) {
					this.router.navigate(['/billing'])
				}
				return throwError(event)
			}) as any,
		)
	}
}
